import {makeStyles} from '@material-ui/core/styles'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import ConfigAccordionBase from './ConfigAccordionBase'


const AppearanceAccordion = ({className, label, optionList, handleChange, onEditMode, value}) => {
    const classes = useStyles({onEditMode})

    return (
        <ConfigAccordionBase label={label} className={className} onEditMode={onEditMode}>
            <FormControl className={classes.formControl}>
                <RadioGroup
                    className={classes.form}
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    defaultValue="Default"
                    value={value}
                    onChange={(e)=> handleChange(e.target.value)}
                >
                    {
                        optionList.map((option, index)=>(
                            <div key={index} className={`${classes.option} ${option.name===value && classes.selectedOption}`} >
                                <div onClick={()=> {if(onEditMode){handleChange(option.name)}}}>
                                    {option.thumbnail}
                                </div>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Radio checkedIcon={<CheckBoxIcon />} icon={<CheckBoxOutlineBlankIcon/>} className={classes.radio} />}
                                    value={option.name}
                                    label={option.name}
                                />
                            </div>
                        ))
                    }
                </RadioGroup>
            </FormControl>
        </ConfigAccordionBase>
    )
}

export default AppearanceAccordion

const useStyles = makeStyles((theme)=>({
    root: {},
    form: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    formControl: {
        width: '100%'
    },
    label: {
        color: theme.palette.tertiary.main,
        display: 'flex',
        justifyContent: 'center',
        opacity: .5,
        transition: 'opacity .25s',
        cursor: props => props.onEditMode ? 'pointer' : 'default',
        pointerEvents: props => props.onEditMode ? 'auto' : 'none',
    },
    option: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& .MuiRadio-root': {
            padding: '9px 9px 9px 0'
        },
        '&>div': {
            boxShadow: '1px 3px 5px #C7C9CB',
            borderRadius: 23,
            overflow: 'hidden',
            cursor: props => props.onEditMode ? 'pointer' : 'default',
            transition: 'box-shadow .25s'
        }
    },
    radio: {
        opacity: props => props.onEditMode ? 1 : 0,
        pointerEvents: props => props.onEditMode ? 'auto' : 'none',
        cursor: props => props.onEditMode ? 'pointer' : 'default',
        transition: 'opacity .25s',
    },
    selectedOption: {
        '&>div': {
            boxShadow: '1px 3px 5px #696969',
        },
        '& .MuiFormControlLabel-root': {
            opacity: 1,
        },
        '& .MuiFormControlLabel-label': {
            fontWeight: 500
        }
    }
}))
